import classNames from 'classnames';
import { IsPackageComponentContext } from 'context/IsPackageComponentContext';
import { ComponentProps, useContext, useEffect, useState } from 'react';
import { useAppSelector } from 'store/index';
import styles from './LoginButtonComponent.module.scss';
export interface LoginButtonComponentProps {
	children: React.ReactNode;
	onClick?: ComponentProps<'button'>['onClick'];
}

export const LoginButtonComponent: React.FC<LoginButtonComponentProps> = ({ children, onClick }) => {
	const { isVisible } = useContext(IsPackageComponentContext);

	const [showLoginButton, setShowLoginButton] = useState<boolean>(false);
	const customer = useAppSelector((state) => state.customer);

	useEffect(() => {
		if (customer.isDataFetched && !customer.isLoggedIn) {
			setShowLoginButton(true);
		}
	}, [customer]);

	return (
		showLoginButton && (
			<button
				type='button'
				className={classNames(styles.LoginButton, isVisible && styles['LoginButton--package'])}
				onClick={onClick}
			>
				<svg
					xmlns='http://www.w3.org/2000/svg'
					width='24'
					height='24'
					viewBox='0 0 24 24'
					fill='none'
				>
					<rect
						width='24'
						height='24'
						rx='12'
						fill='#EFEFEF'
					/>
					<path
						d='M15.2 7.79883C18.6462 7.79883 20.1 9.75075 20.1 12.1488C20.1 14.5469 18.6462 16.4988 15.2 16.4988H13.8V7.79883H15.2Z'
						fill='#0060E6'
					/>
					<path
						d='M8.52269 7.5C7.37306 7.5 6.44239 8.46837 6.44239 9.66457C6.44239 10.8608 7.37306 11.8291 8.52269 11.8291C9.67232 11.8291 10.6029 10.8608 10.6029 9.66457C10.6029 8.46837 9.67232 7.5 8.52269 7.5ZM8.52269 12.6266C6.60664 12.6266 5.01903 13.7658 4.80005 16.5H12.3C12.0811 13.7658 10.4935 12.6266 8.52269 12.6266Z'
						fill='#0060E6'
					/>
				</svg>
				{children}
			</button>
		)
	);
};
